<sl-title title="Users"></sl-title>
<mat-card class="linq-card--legacy nc-accounts-conversion">
	<sl-filters [options]="filterOptions" [config]="filterConfig" [fields]="filterFields" [filters]="filters" [showChipKey]="false"
		(filtersUpdated)="filtersUpdated($event)">
		<span class="spacer"></span>
		<sl-title-buttons [buttons]="titleButtons"></sl-title-buttons>
	</sl-filters>
	<sl-table [data]="data" [config]="config" [filters]="filters"></sl-table>
</mat-card>
